const getRelatedFields = (steps, keyName: string) => {
  const fields = steps.flatMap((s) => {
    return s.fields;
  });

  const childrenRelatedFields = fields
    .filter((field) => field.name.includes(keyName))
    .map((field) => ({
      name: field.name,
      defaultValue: field.defaultValue,
      value: field.value,
    }));

  return childrenRelatedFields;
};

export const childrenDataArray = (initialSteps) => {
  const childrenRelatedFields = getRelatedFields(
    initialSteps,
    'geselecteerdeKinderen'
  );

  const transformedChildren = childrenRelatedFields.reduce(
    (initialArr, field) => {
      const value = field.value;
      const fieldName = field.name.split('-')[2];
      const childId = field.name.match(/\[(.*?)\]/)[1];

      initialArr[childId] = {
        ...initialArr[childId],
        [fieldName]: value,
      };

      return initialArr;
    },
    []
  );

  return transformedChildren;
};

export const adultChildrenData = (initialSteps) => {
  const childrenRelatedFields = getRelatedFields(initialSteps, 'kinderen');

  const transformedChildren = childrenRelatedFields.reduce(
    (initialArr, field) => {
      const value = field.value;
      const fieldName = field.name.split('-')[2];
      const childId = field.name.match(/\[(.*?)\]/)[1];

      const subName = field.name.split('-')[3];

      initialArr[childId] = {
        ...initialArr[childId],
        [fieldName]: {
          ...initialArr[childId]?.[fieldName],
          [subName]: value,
        },
      };

      return initialArr;
    },
    []
  );

  return transformedChildren.filter(Boolean);
};

export const oldInsurerData = (initialSteps) => {
  const relatedFields = getRelatedFields(
    initialSteps,
    'huidigeZorgverzekeringenIncludingInvalid'
  );

  const objectsToArray = relatedFields.reduce((initialArr, field) => {
    const value = field.value;
    const fieldName = field.name.split('-')[2];
    const index = field.name.match(/\[(.*?)\]/)[1];

    initialArr[index] = {
      ...initialArr[index],
      [fieldName]: value,
    };

    return initialArr;
  }, []);

  return objectsToArray.filter(Boolean);
};

export const getFormName = (steps, field) => {
  let formName;
  for (const step of steps) {
    const transformedName = field.name.replaceAll('.', '-');

    const find = step.fields.find((f) => f.name === transformedName);

    if (find) {
      formName = step.name;
    }
  }

  return formName;
};
